export const stats = {
  general: {
    block: {
      main: 'Calls',
      acd: 'ACD',
      asr: 'ASR'
    },

    filter: {
      group_by: {
        title: 'Group by',
        values: {
          day: 'Day',
          month: 'Month',
          country: 'Country'
        }
      },

      type: {
        title: 'Type',
        values: {
          outgoing: 'Outgoing',
          incoming: 'Incoming'
        }
      },

      source: {
        title: 'Data source'
      },

      destination: {
        title: 'Destination'
      },

      voice_stats: {
        trunk: {
          title: 'Trunk'
        },
        destination_b_number: {
          title: 'Direction (B-number)'
        },

        source: {
          title: 'Original A-number'
        },
        destination: {
          title: 'Country'
        }
      }
    },

    field: {
      group: 'Group',
      total: 'Total',
      asr: 'ASR',
      acd: 'ACD',
      duration: 'Duration',
      duration_billed: 'Duration billed',
      cost: 'Cost'
    }
  },

  detailed: {
    field: {
      country: 'Country',
      source_incoming: 'Original A-number',
      source_outgoing: 'Substituted A-number',
      destination: 'Direction (B-number)',
      duration: 'Duration',
      duration_billed: 'Duration billed',
      cost: 'Cost',
      date: 'Date',
      call_type: 'Call type',
      audio: 'Audio'
    }
  }
};
